import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

export const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleAuthCallback } = useAuth();

  useEffect(() => {
    const processCallback = async () => {
      const token = searchParams.get('token');

      if (!token) {
        navigate('/login?error=missing_token', { replace: true });
        return;
      }

      try {
        await handleAuthCallback(token);
        navigate('/', { replace: true });
      } catch (error) {
        navigate('/login?error=session_failed', { replace: true });
      }
    };

    void processCallback();
  }, [searchParams, handleAuthCallback, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <p className="text-sm text-gray-600">Connexion en cours...</p>
    </div>
  );
};
